import en from './translations/en.json'
import br from './translations/br.json'

export default {
    en, br
}